import React from "react";

const LoginError = () => {
    return (
        <div className="loginError">
            <h1>Oops... something went wrong.</h1>
        </div>
    );
};

export default LoginError;